import React from 'react'

interface InputProps extends Partial<Omit<React.HTMLProps<HTMLInputElement>, 'onChange'>> {
	label: string
	onChange: (value: string) => void
	type?: 'text' | 'email'
}

const Input: React.FC<InputProps> = ({ type = 'text', label, onChange, ...props }) => (
	<label className="input">
		<span className="input__label">{label}</span>

		<input
			{...props}
			type={type}
			className="input__field"
			onChange={e => onChange(e.target.value)}
		/>
	</label>
)

export default Input
